import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { logout } from '../actions/auth-actions';
import { APP_NAME } from '../utils';

const Header = ({ toggleSidebar }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleLogout = (e) => {
    e.preventDefault();
    setMenuOpen(false);
    dispatch(logout());
    window.location.href = '/auth/login';
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const firstName = user?.name?.split(' ')[0] ?? 'U';
  const initial = firstName.charAt(0).toUpperCase();

  return (
    <header id="header" className="header duo-header fixed-top">
      <div className="duo-header__inner">
        <div className="duo-header__left">
          <button
            type="button"
            className="duo-header__menu-btn"
            onClick={toggleSidebar}
            aria-label="Ouvrir ou fermer le menu"
          >
            <i className="bi bi-list" aria-hidden />
          </button>
          <Link to="/" className="duo-header__brand">
            <img src="/assets/img/logo.png" alt={APP_NAME} className="duo-header__logo" />
          </Link>
        </div>

        <div className="duo-header__right" ref={menuRef}>
          <button
            type="button"
            className="duo-header__profile-btn"
            onClick={() => setMenuOpen((open) => !open)}
            aria-expanded={menuOpen}
            aria-haspopup="true"
          >
            <span className="duo-header__avatar" aria-hidden>
              {initial}
            </span>
            <span className="duo-header__user-name">{user?.name}</span>
            <i className={`bi bi-chevron-down duo-header__chevron${menuOpen ? ' is-open' : ''}`} aria-hidden />
          </button>

          {menuOpen && (
            <div className="duo-header__dropdown" role="menu">
              <div className="duo-header__dropdown-head">
                <span className="duo-header__dropdown-avatar" aria-hidden>
                  {initial}
                </span>
                <div>
                  <p className="duo-header__dropdown-name">{user?.name}</p>
                  <p className="duo-header__dropdown-email">{user?.email}</p>
                </div>
              </div>

              <ul className="duo-header__dropdown-list">
                <li>
                  <Link
                    to="/edit-profile"
                    className="duo-header__dropdown-item"
                    onClick={() => setMenuOpen(false)}
                  >
                    <i className="bi bi-person" aria-hidden />
                    Mon compte
                  </Link>
                </li>
                <li>
                  <Link
                    to="/rapports"
                    className="duo-header__dropdown-item"
                    onClick={() => setMenuOpen(false)}
                  >
                    <i className="bi bi-journal-text" aria-hidden />
                    Rapports
                  </Link>
                </li>
                <li>
                  <Link
                    to="/finance-impots"
                    className="duo-header__dropdown-item"
                    onClick={() => setMenuOpen(false)}
                  >
                    <i className="bi bi-cash-coin" aria-hidden />
                    Finance et Impôts
                  </Link>
                </li>
                <li>
                  <a
                    className="duo-header__dropdown-item"
                    href="mailto:info@nextmux.net?subject=Besoin%20d'aide"
                    onClick={() => setMenuOpen(false)}
                  >
                    <i className="bi bi-question-circle" aria-hidden />
                    Besoin d&apos;aide ?
                  </a>
                </li>
                <li className="duo-header__dropdown-divider" />
                <li>
                  <button
                    type="button"
                    className="duo-header__dropdown-item duo-header__dropdown-item--danger"
                    onClick={handleLogout}
                  >
                    <i className="bi bi-box-arrow-right" aria-hidden />
                    Déconnexion
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
